<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{ "duplicate" | translate }}</h4>
</div>
<div class="modal-body">
    <div class="form-group mb-20" [class.has-error]="name.invalid && name.dirty">
        <label class="control-label">
            {{ "page_title" | translate }}
        </label>

        <input
            class="form-control"
            type="text"
            name="pageName"
            autofocus
            spPageNameCheck
            [spPageNameOptions]="{ siteId: siteId.toString() }"
            [formControl]="name"
        />

        <ng-container *ngIf="name.invalid && name.dirty; else showHint">
            <p *ngIf="name.hasError(savePageErrorCodes.PAGE_NAME_ALREADY_USED)" class="help-block small">
                {{ "page_name_taken" | translate }}
            </p>
        </ng-container>

        <ng-template #showHint>
            <p class="help-block small">
                {{ "page_name_hint" | translate }}
            </p>
        </ng-template>
    </div>

    <div class="form-group mb-20" [class.has-error]="url.invalid && url.dirty">
        <label class="control-label">
            {{ "site_domain_url" | translate }}
        </label>

        <div class="input-group">
            <div class="input-group-addon overflow-url" [tooltip]="siteDomain" tooltipPlacement="top">
                <span>{{ siteDomain }}/</span>
            </div>
            <input
                class="form-control"
                type="text"
                name="url"
                spPageUrlCheck
                [spPageUrlOptions]="{ siteId: siteId.toString() }"
                [formControl]="url"
            />
        </div>
        <ng-container *ngIf="url.dirty">
            <p *ngIf="url.hasError(savePageErrorCodes.PAGE_URL_ALREADY_USED)" class="help-block small">
                {{ "page_url_taken_error" | translate }}
            </p>
            <p *ngIf="url.hasError(savePageErrorCodes.PAGE_URL_INVALID)" class="help-block small">
                {{ "page_url_invalid" | translate }}
            </p>
            <p *ngIf="url.hasError(savePageErrorCodes.PAGE_URL_RESERVED)" class="help-block small">
                {{ "page_url_reserved" | translate }}
            </p>
        </ng-container>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-default" [disabled]="form.disabled" (click)="onCancel()">
        {{ "cancel" | translate }}
    </button>

    <button type="button" class="btn btn-success" [disabled]="disableConfirm" (click)="onConfirm()">
        {{ "duplicate" | translate }}
    </button>
</div>
